import React from 'react';
import PropTypes from 'prop-types';

import AccImage from 'images/new_ui/icf/acc.png';
import MccImage from 'images/new_ui/icf/mcc.png';
import PccImage from 'images/new_ui/icf/pcc.png';

export default function Icf({ coach }) {
  if (!coach.attributes.icf) {
    return null;
  }

  let icfImage = null;

  switch (coach.attributes.icf.type) {
    case 'acc':
      icfImage = AccImage;
      break;

    case 'pcc':
      icfImage = PccImage;
      break;

    case 'mcc':
      icfImage = MccImage;
      break;

    default:
      icfImage = null;
  }

  return (
    <>
      <h6 className="mb-3">
        ICF
      </h6>

      <div className="mb-4 fw-light">
        <img
          src={icfImage}
          alt="ICF"
          width="144"
          height="144"
        />
      </div>
    </>
  );
}

Icf.propTypes = {
  coach: PropTypes.object.isRequired,
};
